import React from 'react';
import PropTypes from 'prop-types';

// Shared Components
import styles from './EntityLanguagesLabel.scss';
import { LANGUAGE_CODE_TO_TITLE } from '../../../constants/Language';

export default function EntityLanguagesLabel({ languages }) {
  const languageTitles = languages.map(
    language => LANGUAGE_CODE_TO_TITLE[language]
  );
  return (
    <div className={styles.entityLanguagesLabel}>
      {languageTitles.join(', ')}
    </div>
  );
}

EntityLanguagesLabel.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string),
};
